"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _styledComponents = require("styled-components");
// fun fact: this is all their useTheme function does too
// https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/hooks/useTheme.js
/**
 * Poor man's alias for styled-components v5's
 * `useTheme` hook until we find time to upgrade.
 */
var useTheme = function useTheme() {
  return (0, _react.useContext)(_styledComponents.ThemeContext);
};
var _default = useTheme;
exports["default"] = _default;
//# sourceMappingURL=useTheme.js.map